import React from "react";

import { ReactComponent as DeleteIcon } from "../../../assets/images/environment/delete.svg";
import { ReactComponent as FileStatusIcon } from "../../../assets/images/environment/xls-file-ring.svg";

import "./FileItem.css";

export default function FileItem(props) {
  const {
    fileData, toggleDeleteConfirmation, returnFileSize,
  } = props;

  return (
    <li className={`UploadExcelFileItem uploaded-files-item ${fileData.errorMessages ? "uploaded-files-error-item" : ""}`}>
      <div className="uploaded-files-item-main">
        <div className="file-icon-and-name-container">
          <FileStatusIcon className={`file-status-${fileData.apiStatus ?? "not-submitted"}`} width={40} height={40} />
          <div>
            <p className="env-uploaded-file-text">{fileData.path}</p>
            <div className="uploaded-files-item-file-size">
              {returnFileSize(fileData.size)}
            </div>
          </div>
        </div>

        <div className={`uploaded-files-item-right ${fileData.errorMessages ? "uploaded-files-error-item-right" : ""}`}>
          {/* {fileData.apiStatus && fileData.apiStatus === "success" && (
            <div className="uploaded-files-item-error-text">
              <div className="uploaded-files-item-text-title uploaded-files-item-success-text">
                Success
              </div>
            </div>
          )} */}
          {(fileData.apiStatus === undefined || fileData.apiStatus === "failed") && (
            <div className="uploaded-files-item-delete" onClick={() => toggleDeleteConfirmation("file-modal", true, fileData)}>
              <DeleteIcon width={7.25} height={7.25} />
            </div>
          )}
        </div>
      </div>
      {fileData.errorMessages && (
        <div className="uploaded-files-item-error-text-title-body">
          <p className="uploaded-files-item-text-title uploaded-files-item-error-text">
            {fileData.errorMessages.title}
          </p>
          <p>
            {fileData.errorMessages.body}
          </p>
        </div>
      )}
    </li>
  );
}
